// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__9ii8H","row":"Node_row__3m6xb","label":"Node_label__1aa-B","footer":"Node_footer__NMP4x"};